import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";

import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from "@mui/icons-material/Language";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationContainer from "../common/NotificationContainer";
import ControlledSwitches from "../common/Checked";
import Modal from "../common/Modal";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { onMessageListener } from "../../firebase";
import translate from "../../i18n/translate";
import { intl } from "../../i18n/provider";
import Notiflix from "notiflix";

import { logoutUser } from "./../../actions/userAction";
import { userData } from "../../actions/userAction";
import { DarkTheme } from "../../actions/darkTheme";
import { getNotifications } from "../../actions/notificationActions";

import logo from "../../assests/images/logo/black-logo.svg";
import whiteLogo from "../../assests/images/logo/white-logo.svg";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import { AdminPanelSettingsSharp } from "@mui/icons-material";
import { ShowChartOutlined } from "@mui/icons-material";
import "./nav.css";
import { useIsAdmin, useIsRtl } from "../../shared/hooks/ppHooks.js";
import { getCSSVersionString } from "../../shared/constants/version";
import { LOCALES } from "../../i18n/locales";
import AstroWidget from "../common/AstroWidget";
import EarthquakeWidget from "../common/EarthquakeWidget";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Switch,
  Avatar,
  Button,
  Box,
  Container,
} from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import MenuIcon from "@mui/icons-material/Menu";
import Collapse from "@mui/material/Collapse";
import DynamicLogo from "shared/components/DynamicLogo";
import useIsMobile from "shared/hooks/useIsMobile";

const Navbar = ({
  isAuthenticated,
  logoutUser,
  userData,
  user,
  isDarktheme,
  DarkTheme,
  getNotifications,
  list,
}) => {
  const history = useHistory();
  // Reactive mobile flag: re-renders the navbar when viewport crosses 768px,
  // so the hamburger / desktop nav swap is correct after a resize or rotate.
  // Aliased as IS_MOBILE_DISPLAY locally so the existing usages elsewhere
  // in this file don't need to be touched.
  const IS_MOBILE_DISPLAY = useIsMobile();
  const [logoutModal, setLogOutModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [newNotification, setNewNotification] = useState(false);
  const [langMenuAnchor, setLangMenuAnchor] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const { isAdmin, isReseller } = useIsAdmin();
  const isAdminOrReseller = isAdmin || isReseller;
  const isRtL = useIsRtl();

  const currentLang = localStorage.getItem("langCity") || LOCALES.ENGLISH;

  const items = [
    { to: "/seller_credit", show: true, label: "seller credits" },
    { to: "/report", show: true, label: "Report" },
    { to: "/add_credits", show: isAdminOrReseller, label: "add credits" },
    // { to: "/messages", show: true, label: "messages" },
    // { to: "/contactus", show: true, label: "Contact Us" },
    { to: "/discounts", show: true, label: "discounts" },
    { to: "/credits", show: isAdminOrReseller, label: "credits" },
    { to: "/seller_debt", show: isAdminOrReseller, label: "Debt" },
    { to: "/payments", show: isAdminOrReseller, label: "payments" },
    { to: "/system_balance", show: isAdmin, label: "system_balance" },
    { to: "/system_support", show: isAdmin, label: "system_support" },
    { to: "/dealers", show: isAdmin, label: "Send Whatsapp" },
  ];

  const showIsraeliCompanies = async () => {
    const random = Math.floor(Math.random() * 1000000000000000000);
    history.push("/", {
      random: random,
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      setTimeout(() => userData(history), 500);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Firebase foreground notification listener
  useEffect(() => {
    if (!isAuthenticated) return;

    const setupListener = async () => {
      try {
        onMessageListener()
          .then((payload) => {
            console.log('Received foreground message:', payload);
            
            // Show floating notification
            const title = payload.notification?.title || payload.data?.title || 'New Notification';
            const body = payload.notification?.body || payload.data?.body || '';
            
            Notiflix.Notify.info(`${title}${body ? ': ' + body : ''}`);
            
            getNotifications();
            notificationAudo();
            setNewNotification(true);
          })
          .catch((err) => {
            console.error('Foreground notification error:', err);
          });
      } catch (err) {
        console.error('Setup listener error:', err);
      }
    };

    setupListener();

    // Cleanup is handled by Firebase internally
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const headerData = [
    {
      id: 1,
      icon: <PermPhoneMsgIcon color="success" />,
      linkTo: "/contactus",
      title: translate("Contact Us"),
      condition: isAuthenticated,
    },
    {
      id: 4,
      icon: <ShowChartOutlined color="warning" />,
      onClick: showIsraeliCompanies,
      title: "F9",
      condition: true,
    },
    {
      id: 2,
      icon: <AdminPanelSettingsSharp color="error" />,
      linkTo: "/admin",
      title: translate("Admin Panel"),
      condition: isAdmin,
    },
    {
      id: 3,
      icon: <ListIcon />,
      onClick: () => {
        setShowSubMenu(!showSubMenu);
      },
      title: translate("Report"),
      condition: isAuthenticated,
    },
    {
      id: 5,
      icon: <LogoutIcon />,
      onClick: () => setLogOutModal(true),
      title: translate("Logout"),
      condition: isAuthenticated,
    },
  ];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleNavigation = (path) => {
    history.push(path);
    setDrawerOpen(false);
  };

  const handleChange = (e) => {
    if (isDarktheme) {
      DarkTheme(false);
    } else {
      DarkTheme(true);
    }
  };
  const onLogoutClick = () => {
    logoutUser(history);
  };

  const handleLanguageMenuOpen = (event) => {
    setLangMenuAnchor(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setLangMenuAnchor(null);
  };

  const handleLanguageChange = (lang) => {
    localStorage.setItem("langCity", lang);
    handleLanguageMenuClose();
    window.location.reload(); // Reload to apply language change
  };

  const getLanguageLabel = (lang) => {
    const labels = {
      [LOCALES.ENGLISH]: "English",
      [LOCALES.ARABIC]: "العربية",
      [LOCALES.ISRAEL]: "עברית",
    };
    return labels[lang] || "English";
  };

  const notificationAudo = () => {
    try {
      const audio = document.querySelector(".audio-play");
      if (audio) {
        audio.currentTime = 0;
        const playPromise = audio.play();
        
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('Notification sound played successfully');
            })
            .catch((error) => {
              console.warn('Notification sound blocked by browser:', error);
              // Browser may block autoplay, this is normal
            });
        }
      }
    } catch (error) {
      console.error('Error playing notification sound:', error);
    }
  };

  const mobileMenu = (
    <Box sx={{ width: 250 }} role="presentation">
      <List>
        <ListItem
          button
          onClick={() => handleNavigation("/Profile")}
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
        >
          <AccountCircleIcon 
            sx={{ 
              width: 32, 
              height: 32,
              color: "#047857"
            }}
          />
          <ListItemText primary={translate("Profile")} />
        </ListItem>
        <Divider />
        <ListItem
          button
          onClick={handleLanguageMenuOpen}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <ListItemIcon>
            <LanguageIcon color="primary" />
          </ListItemIcon>
          <ListItemText 
            primary={translate("Language")} 
            secondary={getLanguageLabel(currentLang)}
            secondaryTypographyProps={{
              sx: { 
                fontSize: "0.75rem",
                color: "#1976d2",
                fontWeight: "bold"
              }
            }}
          />
        </ListItem>
        <Divider />
        {headerData.map((data) =>
          data.condition ? (
            <React.Fragment key={data.id}>
              <ListItem
                button
                onClick={() =>
                  data.onClick ? data.onClick() : handleNavigation(data.linkTo)
                }
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ListItemIcon>{data.icon}</ListItemIcon>
                <ListItemText primary={data.title} />
              </ListItem>
              {data.id === 3 && (
                <Collapse in={showSubMenu} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {items.map((item) =>
                      item.show ? (
                        <ListItem
                          key={item.to}
                          button
                          component={Link}
                          to={item.to}
                          sx={{ pl: 4 }}
                        >
                          <ListItemText primary={item.label} />
                        </ListItem>
                      ) : null
                    )}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ) : null
        )}

        {/* <Box sx={{ display: "flex", alignItems: "center", padding: 2 }}>
          <ControlledSwitches check={isDarktheme} Change={handleChange} />
          <ListItemText primary={translate("Dark Mode")} />
        </Box> */}
      </List>
    </Box>
  );

  return (
    <Container maxWidth="xl">
      <nav
        className={
          !isDarktheme
            ? "navbar navbar-expand-lg navbar-light "
            : "navbar navbar-expand-lg dark-navbar-light "
        }
      >
        <NotificationContainer
          list={list}
          newNotification={newNotification}
          setNewNotification={setNewNotification}
        />
        {/* <div id='notification-bar'></div> */}

        <Link className="navbar-brand my-0 p-0" to="/">
          <Box sx={{ position: "relative", display: "flex", alignItems: "center", gap: 2 }}>
            <div className="nav-imsg">
              <DynamicLogo
                width="auto"
                height="28"
                className="d-inline-block align-top "
              />
            </div>
            {!IS_MOBILE_DISPLAY && isAuthenticated && (
              <Box sx={{ position: "absolute", left: "100%", ml: 1, top: "50%", transform: "translateY(-50%)" }}>
                <AstroWidget compact={true} />
              </Box>
            )}
          </Box>
        </Link>
        {IS_MOBILE_DISPLAY && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
        )}

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          {/* {!IS_MOBILE_DISPLAY && (
            <div
              className="ControlledSwitches left"
              style={{
                paddingLeft: "30px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <ControlledSwitches check={isDarktheme} Change={handleChange} />
              <p
                style={
                  !isDarktheme
                    ? { paddingTop: "16px" }
                    : { paddingTop: "16px", color: "white" }
                }
              >
                {intl.formatMessage({ id: "Dark Mode" })}
              </p>
            </div>
          )} */}
          
          {/* Date and Time Display - Centered */}
          {isAuthenticated && !IS_MOBILE_DISPLAY && (
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "8px 16px",
                backgroundColor: isDarktheme ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
                borderRadius: "8px",
                minWidth: "200px",
              }}
            >
              <Box
                sx={{
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  color: isDarktheme ? "#fff" : "#000",
                  letterSpacing: "0.5px",
                }}
              >
                {currentDateTime.toLocaleDateString(currentLang, {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </Box>
              <Box
                sx={{
                  fontSize: "1.125rem",
                  fontWeight: 700,
                  color: isDarktheme ? "#4fc3f7" : "#1976d2",
                  marginTop: "2px",
                }}
              >
                {currentDateTime.toLocaleTimeString(currentLang, {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                })}
              </Box>
            </Box>
          )}

          <ul
            className="navbar-nav me-auto mb-2 mb-lg-0 dark-nav-item"
            style={{
              display: "flex",
            }}
          >
            {isAuthenticated && !IS_MOBILE_DISPLAY && (
              <li className="nav-item">
                <div id="notification-secti`on">
                  <Button
                    // component="label"
                    // variant="contained"
                    startIcon={
                      <PermPhoneMsgIcon
                        sx={{
                          marginLeft: 1,
                          marginRight: 1,
                          color: "green",
                          fontSize: "1.5rem",
                        }}
                      />
                    }
                    sx={{ color: "#000", fontSize: "1rem" }}
                    onClick={() => history.push("/contactus")}
                  >
                    {translate("Contact Us")}
                  </Button>
                </div>
              </li>
            )}

            {!isAuthenticated && (
              <li className="nav-item">
                <Link className="nav-link active" to="/signup">
                  {translate("Sign Up")}
                </Link>
              </li>
            )}
            {!isAuthenticated && (
              <li className="nav-item">
                <Link className="nav-link active" to="/signin">
                  {translate("Login")}
                </Link>
              </li>
            )}

            {isAuthenticated && !IS_MOBILE_DISPLAY && (
              <li
                className="nav-item"
                onMouseEnter={() => setShowSubMenu(true)}
                onMouseLeave={() => setShowSubMenu(false)}
              >
                <Link
                  to="/report"
                  className="nav-link active"
                  style={{ cursor: "pointer" }}
                >
                  <ListIcon />
                </Link>

                {showSubMenu && (
                  <div className="sublinks-wrapper">
                    {items.reduce((prev, curr) => {
                      if (curr.show) {
                        prev.push(
                          <Link
                            to={curr.to}
                            className="nav-link"
                            style={{ cursor: "pointer" }}
                          >
                            {translate(curr.label)}
                          </Link>
                        );
                      }
                      return prev;
                    }, [])}
                  </div>
                )}
              </li>
            )}

            {isAuthenticated && isAdmin && !IS_MOBILE_DISPLAY && (
              <li className="nav-item position-relative">
                <a
                  onClick={() => history.push("/admin")}
                  href="#0"
                  className="nav-link active"
                  style={{ cursor: "pointer" }}
                >
                  {translate("Admin Panel")}
                </a>
              </li>
            )}
            {/* Earthquake Widget */}
            {isAuthenticated && !IS_MOBILE_DISPLAY && (
              <li className="nav-item" style={{ marginRight: "10px" }}>
                <EarthquakeWidget compact={true} />
              </li>
            )}

            {/* Language Switcher */}
            {!IS_MOBILE_DISPLAY && (
              <li className="nav-item">
                <IconButton
                  onClick={handleLanguageMenuOpen}
                  sx={{
                    color: isDarktheme ? "white" : "inherit",
                    padding: "8px",
                  }}
                  title={translate("Language")}
                >
                  <LanguageIcon sx={{ fontSize: "1.75rem" }} />
                </IconButton>
                <Menu
                  anchorEl={langMenuAnchor}
                  open={Boolean(langMenuAnchor)}
                  onClose={handleLanguageMenuClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      minWidth: 150,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => handleLanguageChange(LOCALES.ENGLISH)}
                    selected={currentLang === LOCALES.ENGLISH}
                    sx={{
                      fontWeight:
                        currentLang === LOCALES.ENGLISH ? "bold" : "normal",
                      color:
                        currentLang === LOCALES.ENGLISH ? "#1976d2" : "inherit",
                    }}
                  >
                    🇺🇸 English
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleLanguageChange(LOCALES.ARABIC)}
                    selected={currentLang === LOCALES.ARABIC}
                    sx={{
                      fontWeight:
                        currentLang === LOCALES.ARABIC ? "bold" : "normal",
                      color:
                        currentLang === LOCALES.ARABIC ? "#1976d2" : "inherit",
                      fontFamily: "Dubai, sans-serif",
                    }}
                  >
                    🇵🇸 العربية
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleLanguageChange(LOCALES.ISRAEL)}
                    selected={currentLang === LOCALES.ISRAEL}
                    sx={{
                      fontWeight:
                        currentLang === LOCALES.ISRAEL ? "bold" : "normal",
                      color:
                        currentLang === LOCALES.ISRAEL ? "#1976d2" : "inherit",
                    }}
                  >
                    🇮🇱 עברית
                  </MenuItem>
                </Menu>
              </li>
            )}

            {isAuthenticated && !IS_MOBILE_DISPLAY && (
              <li className="nav-item">
                <Link
                  to="/Profile"
                  className="nav-link active"
                  style={{ cursor: "pointer" }}
                >
                  <AccountCircleIcon 
                    onClick={() => history.push("/Profile")}
                    sx={{ 
                      width: 36, 
                      height: 36,
                      color: "#047857",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        color: "#059669",
                        transform: "scale(1.1)",
                      }
                    }}
                  />
                </Link>
              </li>
            )}

            {isAuthenticated && !IS_MOBILE_DISPLAY && (
              <li className="nav-item">
                <LogoutIcon
                  onClick={() => setLogOutModal(true)}
                  style={
                    !isDarktheme
                      ? { cursor: "pointer", margin: "0 16px" }
                      : {
                          cursor: "pointer",
                          margin: "0 16px",
                          color: "white",
                        }
                  }
                />
              </li>
            )}
          </ul>
        </div>

        <Modal
          visible={logoutModal}
          onClose={() => setLogOutModal(false)}
          title={"logout"}
          width={"30vw"}
        >
          <div className="fire-free-modal mt-4">
            <h4>{intl.formatMessage({ id: "log out message" })}</h4>
            <div className="btn-section">
              <button
                style={{ margin: "0 16px" }}
                className="btn btn-primary"
                onClick={onLogoutClick}
              >
                {intl.formatMessage({ id: "logout" })}
              </button>
              <button
                className="btn btn-danger"
                onClick={() => setLogOutModal(false)}
              >
                {intl.formatMessage({ id: "Close" })}
              </button>
            </div>
          </div>
        </Modal>
        <audio 
          className="audio-play" 
          src="/audios/pristine-609.mp3"
          preload="auto"
        />
        {/* Dynamic Version Display */}
        <div className="navbar-version-display">{getCSSVersionString()}</div>
      </nav>
      <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle}>
        {mobileMenu}
      </Drawer>
    </Container>
  );
};
const mapStateToProps = ({
  auth: { userData, isAuthenticated },
  darkTheme: { isDarktheme },
  notification: { list },
}) => ({
  isAuthenticated,
  user: userData,
  isDarktheme,
  list,
});
export default connect(mapStateToProps, {
  logoutUser,
  userData,
  DarkTheme,
  getNotifications,
})(Navbar);
